import { useFormat } from '@ideavivat/vivat-2';

import { toCommaFormat } from '@/utils';

export default {
  types: {
    _primaryControls: {
      width: '3rem',
    },
    _increment: {
      name: 'ลำดับ',
      width: '3rem',
      class: 'text-center',
    },
    code: {
      name: 'รหัสสินค้า',
      width: '8rem',
    },
    refCode: {
      name: 'รหัสอ้างอิง',
      width: '8rem',
    },
    name: {
      name: 'รายการสินค้า',
      width: '2fr',
    },
    unit: {
      name: 'หน่วย',
      width: '6rem',
    },
    productGroup: {
      name: 'ประเภท',
      width: '10rem',
      filter(val: any, row: any) {
        if (val) {
          return row.item?.productGroup?.name;
        }
        return '-';
      },
    },
    weightPerUnit: {
      name: 'น้ำหนัก/หน่วย',
      width: '6rem',
      class: 'text-right',
      filter(val: any, row: any) {
        return `${toCommaFormat(val, 0, 2)} Kg`;
      },
    },
    deliveryFeePerUnit: {
      name: 'ค่าจัดส่ง/หน่วย(บาท)',
      width: '10rem',
      class: 'text-center',
    },
    dimensional: {
      name: 'ปริมาตร(กxยxส)',
      width: '14rem',
      class: 'mr-2 text-left',
      // eslint-disable-next-line
      filter(val: any, row: any) {
        return `${toCommaFormat(row.item.width, 5, 5)} x ${toCommaFormat(row.item.length, 5, 5)} x ${toCommaFormat(row.item.height, 5, 5)}`;
      },
    },
    updatedAt: {
      name: 'เคลื่อนไหวล่าสุด',
      width: '10rem',
      filter(val: any) {
        return useFormat.date(val).displayShortThaiDateTime();
      },
    },
  },
  sortable: [
  ],
};
